import { cn } from '@/lib/utils';

import Section, {
  DataTrackerSectionProps,
} from '@/components/atoms/Section/Section';

import { PageData } from '@/app/types';
import { getWrapperMaxWidth, SectionFit } from '@/cms/utils';
import { StrapiTheme } from '@/theme/themeProviderUtils';

export type BlockWrapperProps = {
  children: React.ReactNode;
  contentFit?: SectionFit;
  classNames?: {
    root?: string;
    inner?: string;
  };
  pageData?: PageData;
  theme?: StrapiTheme;
} & DataTrackerSectionProps;

export function BlockWrapper({
  children,
  contentFit = 'contained',
  classNames,
  pageData: _pageData,
  theme: _theme,
  ...rest
}: BlockWrapperProps) {
  return (
    <Section
      {...rest}
      className={cn('w-full px-5 py-8 md:px-20 md:py-16', classNames?.root)}
    >
      <div
        className={cn(
          getWrapperMaxWidth(contentFit),
          'mx-auto my-0',
          classNames?.inner
        )}
      >
        {children}
      </div>
    </Section>
  );
}
